module.exports = __webpack_public_path__ + "img/icon-org-appeal.b4a498a4.svg";